<template>
    <div class="public_bg">
        <div class="nurse_top">
            <div style="height: 54px; line-height: 54px">
                <img style="vertical-align: middle" src="@/assets/beadhouse/juxing.png" />
                <span>人脸统计</span>
            </div>
        </div>
        <div class="row_link clearfix">
            <div class="item" v-for="(item, index) in infoList" :key="index" @click="handleClick(item.uid)">
                <a>
                    <img :src="item.img" />
                    <h5 style="font-size: 16px">{{ item.title }}</h5>
                    <span>{{ item.text }}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import bus from '@/vuex/eventBus';

export default {
    name: 'FaceStatistics',
    data() {
        return {
            infoList: []
        };
    },
    methods: {
        handleClick(id) {
            switch (id) {
                case 0:
                    bus.$emit('homePage', {
                        type: 'jump',
                        path: '/personnelLibrary',
                        title: '人员库管理'
                    });
                    break;
                case 1:
                    bus.$emit('homePage', {
                        type: 'jump',
                        path: '/faceAccess',
                        title: '人脸门禁管理'
                    });
                    break;
                case 2:
                    bus.$emit('homePage', {
                        type: 'jump',
                        path: '/brushRecord',
                        title: '刷脸记录'
                    });
                    break;
                case 3:
                    bus.$emit('homePage', {
                        type: 'jump',
                        path: '/visitStatistics',
                        title: '来访统计'
                    });
                    break;
                case 4:
                    bus.$emit('homePage', {
                        type: 'jump',
                        path: '/abnormalRecord',
                        title: '异常记录'
                    });
                    break;
                // 仅新增：人脸录入的跳转逻辑
                case 5:
                    bus.$emit('homePage', {
                        type: 'jump',
                        path: '/faceInput',
                        title: '人脸录入'
                    });
                    break;
            }
        },
        getPageData() {
            this.infoList = [
                {
                    img: require('@/assets/beadhouse/xt_cwgl.png'),
                    title: '人员库管理',
                    text: '管理人员信息、人脸头像及证件资料',
                    uid: 0,
                    url: '/personnelLibrary'
                },
                {
                    img: require('@/assets/beadhouse/cardlist.png'),
                    title: '人脸门禁管理',
                    text: '管理门禁设备、IP及安装信息',
                    uid: 1,
                    url: '/faceAccess'
                },
                {
                    img: require('@/assets/beadhouse/accessEvent.png'),
                    title: '刷脸记录',
                    text: '查看来访人员刷脸通行记录',
                    uid: 2,
                    url: '/brushRecord'
                },
                {
                    img: require('@/assets/beadhouse/jiaobanrizhi.png'),
                    title: '来访统计',
                    text: '按天/按月/按人统计来访识别数据',
                    uid: 3,
                    url: '/visitStatistics'
                },
                {
                    img: require('@/assets/beadhouse/banzhangrizhi.png'),
                    title: '异常记录',
                    text: '查看核验错误及相似度异常记录',
                    uid: 4,
                    url: '/abnormalRecord'
                },
                {
                    img: require('@/assets/beadhouse/banzhangrizhi.png'),
                    title: '人脸录入',
                    text: '录入人员人脸信息并绑定身份资料',
                    uid: 5,
                    url: '/faceInput'
                }
            ];
        }
    },
    created() {
        this.getPageData();
    },
    mounted() {}
};
</script>

<style lang="scss" scoped>
.public_bg {
    width: 100%;
    padding: 0 0 20px 0;
    height: 95%;
    background: #fefefe;
    .nurse_top {
        border: 1px #f1eff2 solid;
        background: #f9f7fa;
        position: relative;
        img {
            margin: 14px 12px;
        }
        h5 {
            display: inline-block;
            position: absolute;
            top: 12px;
            font-size: 18px;
        }
    }
    .row_link {
        width: 1259px;
        margin: 34px 35px;
        .item {
            width: 275px;
            height: 99px;
            border: #f0f0f2 1px solid;
            margin-bottom: 34px;
            margin-right: 34px;
            float: left;
            cursor: pointer;
            img {
                float: left;
                margin: 8px 23px 8px 33px;
                margin-right: 16px;
            }
            span {
                color: #666666;
            }
            h5 {
                margin-top: 21px;
                margin-bottom: 8px;
            }
            a:hover {
                color: #333;
            }
        }
        .item:hover {
            border: 1px solid red;
        }
    }
}
</style>
